import { Tooltip } from "react-tooltip";
import { ComponentProps } from "react";

interface FayTooltipProps extends ComponentProps<typeof Tooltip> {}

const FayTooltip = ({
  id = "fay-tooltip",
  children,
  ...props
}: FayTooltipProps) => (
  <div className="tooltip-container">
    <Tooltip id={id} className="fay-tooltip" opacity={1} {...props}>
      {children}
    </Tooltip>
  </div>
);

export default FayTooltip;
